import { createSlice } from '@reduxjs/toolkit';
import { aICompetitionProvidersTypes } from '../enums/aICompetitionProvidersTypes';

const initialState = {
    digitalCuratorship: null,
    methodica: null
}

const assessmentsSlice = createSlice({
    name: "assessments",
    initialState,
    reducers: {
        initDigitalCuratorship(state, action) {
            state.digitalCuratorship = action.payload;
        },
        initAlbertAssessments(state, action) {
            state.methodica = action.payload;
        },
        updateAssessment(state, action) {
            const { challengeId, score, myProviderId } = action.payload;
            const providerName = Object.values(aICompetitionProvidersTypes).find(contest => contest.providerId === myProviderId).name
            const index = state[providerName].findIndex(item => item.challengeId === challengeId);
            if (index !== -1) {
                const newProviderArr = [...state[providerName]];
                newProviderArr[index].score = score;
                if (newProviderArr[index].score != null && newProviderArr[index].score >= 0)
                    newProviderArr[index].complated = true
                state[providerName] = newProviderArr;
            }
        },
        updateDigitalLike(state, action) {
            const index = state.digitalCuratorship.findIndex(item => item.challengeId === action.payload);
            if (index !== -1) {
                if (!state.digitalCuratorship[index].isLike) {
                    if (!state.digitalCuratorship[index].likeCount) {
                        state.digitalCuratorship[index].likeCount = 0
                    }
                    state.digitalCuratorship[index].likeCount += 1;
                    state.digitalCuratorship[index].isLike = true;
                }
            }
        },
        updateAssessmentView(state, action) {
            const index = state.digitalCuratorship.findIndex(item => item.challengeId === action.payload);
            if (index !== -1) {
                if (!state.digitalCuratorship[index].isView) {
                    if (!state.digitalCuratorship[index].viewCount) {
                        state.digitalCuratorship[index].viewCount = 0
                    }
                    state.digitalCuratorship[index].viewCount += 1;
                    state.digitalCuratorship[index].isView = true;
                }
            }
        }
    }
})

export const assessmentsActions = assessmentsSlice.actions;
export default assessmentsSlice
